import { useMemo } from "react";
import { PRODUCTS_MAP } from "../_static";
export default function useProductSelector({ user, organization }) {
    const assertViableAppId = (value) => PRODUCTS_MAP[value] !== undefined;
    const enabledProducts = useMemo(() => {
        const userScopes = (user === null || user === void 0 ? void 0 : user.scopes) || [];
        const isRootUser = userScopes.includes("TE_ROOT_USER");
        const enabledProductSet = new Set(isRootUser
            ? organization.enabledProducts
            : userScopes.map((scope) => scope.split("::")[0]));
        // Ensure specified order
        return Object.values(PRODUCTS_MAP).filter(({ product, hidden }) => enabledProductSet.has(product) && assertViableAppId(product) && !hidden);
    }, [user, organization]);
    return {
        enabledProducts
    };
}
